import { useEffect } from 'react';
const GTM_ID = 'GTM-543ZQKCM';
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Inyecta el contenedor de Google Tag Manager (script + fallback noscript).
 */
export function GoogleTagManager() {
  useEffect(() => {
    if (document.querySelector(`script[data-gtm="${GTM_ID}"]`)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    script.setAttribute('data-gtm', GTM_ID);
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-49" data-mp="2u4ums3ewzzt6">
      <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" title="Google Tag Manager" style={{
      display: 'none',
      visibility: 'hidden'
    }} data-id="element-50" data-mp="2u545d5xmr4ou" />
    </noscript>;
}